// extracted by mini-css-extract-plugin
export default {"navWrap":"styles_navWrap__cVTkU","navBtn":"styles_navBtn__OINYw","navBtn__disabled":"styles_navBtn__disabled__rrtEb"};